import axios from "axios";

const BASE_URL = "https://hrmspayroll.prepstripe.com/api";

// Assign a role to a user
export const assignRoleToUser = async (token, data) => {
  try {
    const response = await axios.post(`${BASE_URL}/assign-role`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Assign or remove permissions from a role
export const assignPermissionsToRole = async (token, data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/assign-permission-role`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

// Assign or remove permissions from a user
export const assignPermissionsToUser = async (token, data) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/assign-permission-user`,
      data,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
